/**
 * 파일 다운로드처리
 *
 * @param {URL|string} url
 * @param {Object} opts fetch 옵션
 *
 * @returns {Promise<Blob>}
 */
export async function urlToDown(url, opts) {
    // 기본옵션
    const defaults = {
        //method: "POST",
        //body: formData,
    };
    const options = {};
    Object.assign(options, defaults, (opts || {}));

    return fetch(url, options).then((res) => {
        if (res.status !== 200) {
            let msg = '출력정보를 불러올 수 없습니다.';
            if (res.headers.has('gonelo-error-message-urlencoded')) {
                msg = decodeURI(res.headers.get('gonelo-error-message-urlencoded'));
            }
            throw new Error(msg);
        }

        return res.blob().then((blob) => {
            let a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = getFilename(res);
            a.click();
            return Promise.resolve(blob);
        });

    });
}


/**
 * fetch 응답에서 파일명을 찾아준다.
 * @param res
 * @param default_name 파일명 파일값
 * @returns {string}
 */
function getFilename(res, default_name) {
    // 기본파일명
    if (! default_name) {
        default_name = 'file';
    }

    // 헤더에서 추출
    if (! res.headers.has('Content-Disposition')) {
        return default_name;
    }
    let disposition = res.headers.get('Content-Disposition');

    let filename = "";
    if (disposition && disposition.indexOf('attachment') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    filename = decodeURI(filename);
    return filename;
}